/**
 * Sanitizes a search query string by stripping zero-width spaces, hidden unicode control characters,
 * soft hyphens, BOM markers, directional formatting, and normalizing non-breaking spaces.
 */
export const sanitizeSearchQuery = (query?: string | null): string => {
  if (!query) return "";

  return query
    // Remove zero-width spaces, joiners, BOM, soft hyphens, word joiners & directional formatting
    .replace(/[\u200B-\u200D\uFEFF\u00AD\u200E\u200F\u202A-\u202E\u2060\u180E]/g, "")
    // Normalize non-breaking spaces and unusual whitespace characters to standard space
    .replace(/[\u00A0\u1680\u2000-\u200A\u202F\u205F\u3000]/g, " ")
    // Remove invisible control characters
    .replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x9F]/g, "");
};
